export default __webpack_public_path__ + "static/media/join-quote.fe91dba7.svg";